// 경주 랠리 완주 상태(기기 로컬) — FR-RALLY-10 메타버스 연계.
// 완주 시 한정 파츠/뱃지 해금. 익명·비식별(코드만).
const RALLY_KEY = "gc_rally_v1";

export interface RallyState {
  completed: boolean;
  rank?: number;
  claimCode?: string;
}

export function loadRallyState(): RallyState {
  try {
    const raw = localStorage.getItem(RALLY_KEY);
    if (!raw) return { completed: false };
    const o = JSON.parse(raw) as Partial<RallyState>;
    return { completed: o.completed === true, rank: o.rank, claimCode: o.claimCode };
  } catch {
    return { completed: false };
  }
}

export function saveRallyState(state: RallyState): void {
  try {
    localStorage.setItem(RALLY_KEY, JSON.stringify(state));
  } catch {
    /* noop */
  }
}

export function isRallyCompleted(): boolean {
  return loadRallyState().completed;
}
